import React, { useEffect, useRef } from 'react';
import ContentList from './ContentList';
import styled from 'styled-components';
import { whenIsIt, autoScroll } from '../utils';
import { FacebookShare, LineShare } from './ShareButtons';
import { setup, breakPoints } from '../config';
import { horizontalPadding, verticalSpace } from './DisplayComponents';
import LiveHeader from './LiveHeader';
import _get from 'lodash/get';

const { originProd } = setup;
const { maxMobile } = breakPoints;

const _ = {
  get: _get,
}

const Container = styled.div`
  margin-top: 30px;
`;

const BlockContainer = styled.div`
  background-color: #FFFFFF;
  border-top: 2px solid ${props => props.theme.blue};
  box-sizing: border-box;
  width: 100%;
  margin-bottom: 30px;
  padding: 16px 0 0 0;
`;

const Time = styled.div`
  display: flex;
  padding: 0 ${horizontalPadding};
  justify-content: space-between;
  > div {
    font-size: 12px;
  }
`;

const Shares = styled.div`
  display: flex;
  padding: 16px 0;
  margin: ${verticalSpace} ${horizontalPadding};
  border-top: 1px solid ${props => props.theme.borderGray};
  > div {
    margin-right: 16px;
  }
`;

const Title = styled.h3`
  padding: 0 ${horizontalPadding};
  margin: ${verticalSpace} 0;
`;

let initialScroll = false;

function usePrevious(value) {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
}

function EventList({
  blockList,
  slicedData,
  targetId,
  location,
}) {
  const { search } = location;
  const searchParams = new URLSearchParams(search);
  let urlTargetId = +searchParams.get('id') || null;

  const Blocks = slicedData.map((block, index) => {
    const { time, timestamp, content, title } = block;
    const url = `${originProd}/?id=${timestamp}`;
    const whenIsItString = whenIsIt({
      timestamp,
    })
    let count = 0;
    let elem = null;
    let images = null;
    return (
      <BlockContainer
        id={timestamp}
        key={timestamp}
        onLoad={(e) => {
          if (urlTargetId && timestamp === targetId && document && !initialScroll) {
            if (count === 0) {
              elem = document.getElementById(timestamp);
              if (elem) images = elem.querySelectorAll('img');
            }
            if (images.length !== 0) {
              if (e.target.nodeName === 'IMG') {
                count++;
                if (count === images.length) {
                  initialScroll = true;
                  let offset = 0;
                  if (window.innerWidth <= maxMobile) {
                    offset = _.get(document.getElementById('infographic'), 'offsetHeight', 0);
                  }
                  autoScroll({
                    targetId,
                    offset,
                  })
                }
              }
            }
          }
        }}
      >
        <Time>
          <div>{whenIsItString}前</div>
          <div>發布時間：{time}</div>
        </Time>
        <Title>
          {title}
        </Title>
        <ContentList
          id={timestamp}
          content={content}
        />
        <Shares>
          <FacebookShare
            target={url}
            type="block"
          />
          <LineShare
            target={url}
            type="block"
          />
        </Shares>
      </BlockContainer>
    )
  });

  const previousSlicedData = usePrevious(slicedData);
  const previousTargetId = usePrevious(targetId);

  useEffect(() => {
    // only run after first render
    if (targetId && Array.isArray(previousSlicedData) && previousSlicedData.length === 0 && slicedData) {
      autoScroll({
        targetId,
      })
      // only run for clicking takeaway
    } else if ((targetId && previousTargetId && previousTargetId !== targetId) || (targetId && !previousTargetId)){
      let offset = 0;
      if (window && document && window.innerWidth <= maxMobile) {
        offset = _.get(document.getElementById('infographic'), 'offsetHeight', 0);
      }
      autoScroll({
        targetId,
        offset,
      })
    }
  }, [targetId, previousTargetId, slicedData])

  return (
    <Container>
      <LiveHeader
        text="即時更新"
      />
      {Blocks}
    </Container>
  )
}

export default EventList;
